import {
  createSpecializationsByUserModel,
  createUserNewsletterModel,
} from "@/forms/form-types/user-model";
import { normalizeFields } from "@/forms/helpers";

export function createFormFields(
  specializations: SelectRawOptions,
  dataForType: DataForType,
  defaultNewsletter: UserNewsletterVM,
  isNewsletterRequired: boolean,
) {
  const model = {
    ...createSpecializationsByUserModel(specializations, dataForType),
    ...(!defaultNewsletter.isSignedUp
      ? createUserNewsletterModel(isNewsletterRequired)
      : {}),
  };

  return normalizeFields(model);
}
